/**
 * Store information about the current user.
 * The user can be a guest or a logged in user.
 */
class Customer {
	constructor(custId = null, custFullName = null, isGuestUser = true) {
		if (custId !== null && typeof custId !== 'number') {
			throw new TypeError('Customer Id must be a number.');
		}
		this.id = custId;
		this.fullName = custFullName || 'Guest';
		this.isGuest = isGuestUser;

		const timeNow = Date.now();
		this.lastActivity = timeNow;
		this.loginTime = timeNow;
		this.emailAddress = '';
	}

	/**
	 * Populate the customer fields given a serialized customer string.
	 * @param {string} savedCustomer serialized customer
	 */
	deserialize(savedCustomer) {
		const customer = JSON.parse(savedCustomer);
		this.id = customer.id;
		this.fullName = customer.fullName;
		this.lastActivity = customer.lastActivity;
		this.loginTime = customer.loginTime;
		this.isGuest = customer.isGuest;
		this.emailAddress = customer.emailAddress;
	}

	/**
	 * Convert this customer object into a serialized string.
	 * @return {string}
	 */
	serialize() {
		return JSON.stringify(this);
	}
}

export default Customer;
